import { render, staticRenderFns } from "./CreateFileRequest.vue?vue&type=template&id=6e7a9a0b&"
import script from "./CreateFileRequest.vue?vue&type=script&lang=js&"
export * from "./CreateFileRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports